import { render, staticRenderFns } from "./ProblemMultiple.vue?vue&type=template&id=c3f6283a&"
import script from "./ProblemMultiple.vue?vue&type=script&lang=js&"
export * from "./ProblemMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports